<script>
	import { mapState } from 'vuex';
	import swal from 'sweetalert';

	export default{
		data(){
			return{
				paste: false,
				proveedor:false,
				steps: [
				{
					target: '[data-v-step="43"]',
					content: `El Pagador Sap correcto debe corresponder al vendor de 6 dígitos.`,
					params: {
						placement: 'top'
					}
				}
				],
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Aceptar'
					}
				}
			}
		},
		computed:{
			...mapState(['ejercicioActivo','tiendaSeleccionada','alertas'])
		},
		mounted(){
			window.$('#tablaPagador.table-format tr:not(:first-child)').click(function(){
				window.$('#tablaPagador.table-format tr:not(:first-child)').removeClass('active');
				window.$(this).toggleClass('active');
			});
			window.$('#pagador-sap-986698').on('shown.bs.modal', () => {
				if(this.alertas){
					this.$tours['pagadorSap'].start();	
				}
			});
		},
		methods:{
			selectProveedor(proveedor){
				this.proveedor = proveedor;
				this.pagadorSAP();
			},
			pagadorSAP(){
				if(this.ejercicioActivo == 'ejercicio-1'){
					if(this.proveedor.acredor != '1000006537'){
						swal({
							title: "¡Atención!",
							text: 'Este proveedor SAP no corresponde al VENDOR a 6 dígitos.',
							icon: "error",
							button: 'Aceptar'
						});
					}else{
						this.$emit('setPPP',this.proveedor);
						window.$('#pagador-sap-986698').modal('hide');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-2'){
					if(this.proveedor.acredor != '1000002828'){
						swal({
							title: "¡Atención!",
							text: 'Este proveedor SAP no corresponde al VENDOR a 6 dígitos.',
							icon: "error",
							button: 'Aceptar'
						});
					}else{
						this.$emit('setPPP',this.proveedor);
						window.$('#pagador-sap-986698').modal('hide');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-3'){
					if(this.proveedor.acredor != '1000456625'){
						swal({
							title: "¡Atención!",
							text: 'Este proveedor SAP no corresponde al VENDOR a 6 dígitos.',
							icon: "error",
							button: 'Aceptar'
						});
					}else{
						this.$emit('setPPP',this.proveedor);
						window.$('#pagador-sap-986698').modal('hide');
					}
				}

				if(this.ejercicioActivo == 'ejercicio-4'){
					if(this.proveedor.acredor != '1000047614'){
						swal({
							title: "¡Atención!",
							text: 'Este proveedor SAP no corresponde al VENDOR a 6 dígitos.',
							icon: "error",
							button: 'Aceptar'
						});
					}else{
						this.$emit('setPPP',this.proveedor);
						window.$('#pagador-sap-986698').modal('hide');
					}
				}

				if(this.ejercicioActivo == 'evaluacion-1' || this.ejercicioActivo == 'evaluacion-2'){
					this.$emit('setPPP',this.proveedor);
					window.$('#pagador-sap-986698').modal('hide');
				}
			}
		}
	}
</script>
<template>
	<div>
		<v-tour name="pagadorSap" :steps="steps" :options="myOptions"/>
		<div id="pagador-sap-986698" class="modal fade" role="dialog">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="header-modal">
						<label>Crear Solicitud Acuerdo: Paso 2 (Información General)</label>
						<div class="modal-header-buttons">
							<button type="button">
								<i class="far fa-window-maximize"></i>	
							</button>
							<button type="button" data-dismiss="modal">
								<i class="fas fa-times"></i>	
							</button>
						</div>
					</div>
					<div class="body-modal">

						<div class="row">
							<div v-if="tiendaSeleccionada == 'autoservicio'" class="col-md-11">
								<p class="fz-15">Nota: <br>
									<i>
										Recuerda que el Pagador SAP correcto corresponde al proveedor HOST a 6 dígitos.
									</i>
								</p>
							</div>
							<div class="col-md-11">
								<!-- <div class="buttons">
									<button @click="pagadorSAP()" > Seleccionar pagador SAP correcto </button>
									<button  @click="crearSolicitud()"> Agregar </button>
									<button> Borrar </button>
									<button> Guardar </button>
									<button> Copiar/Pegar </button>
									<button> Cancelar </button> 
								</div> -->

								<table id="tablaPagador" v-if="ejercicioActivo == 'ejercicio-1'" class="table-proveedor table-format">
									<tr>
										<td><i class="far fa-clone"></i></td>
										<td data-v-step="43">Acreedor</td>
										<td>Sociedad</td>
										<td>Nº cta.anterior</td>
										<td>Razón Social</td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000006537',sociedad:'C031',no_cuenta:'389106',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000006537</td>
										<td>C031</td>
										<td>389106</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV </td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000006538',sociedad:'C031',no_cuenta:'389106082',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000006538</td>
										<td>C031</td>
										<td>389106082</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV  </td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000012379',sociedad:'C031',no_cuenta:'389106924',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000012379</td>
										<td>C031</td>
										<td>389106924</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV  </td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000014910',sociedad:'C031',no_cuenta:'389106920',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000014910</td>
										<td>C031</td>
										<td>389106920</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV  </td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000048895',sociedad:'C031',no_cuenta:'389106952',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000048895</td>
										<td>C031</td>
										<td>389106952</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV  </td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000057640',sociedad:'C031',no_cuenta:'389106922',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000057640</td>
										<td>C031</td>
										<td>389106922</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV  </td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000311020',sociedad:'C031',no_cuenta:'389106923',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000311020</td>
										<td>C031</td>
										<td>389106923</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV  </td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000330023',sociedad:'C031',no_cuenta:'389106921',razon_social:'SCHETTINO HERMANOS S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000330023</td>
										<td>C031</td>
										<td>389106921</td>
										<td>SCHETTINO HERMANOS S DE RL DE CV  </td>
									</tr>
								</table>

								<table v-if="ejercicioActivo == 'ejercicio-2'" class="table-proveedor table-format">
									<tr>
										<td><i class="far fa-clone"></i></td>
										<td data-v-step="43">Acreedor</td>
										<td>Sociedad</td>
										<td>Nº cta.anterior</td>
										<td>Razón Social</td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000002828',sociedad:'C031',no_cuenta:'208715',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000002828</td>
										<td>C031</td>
										<td>208715</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000002830',sociedad:'C031',no_cuenta:'208715060',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000002830</td>
										<td>C031</td>
										<td>208715060</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
									<tr @click="selectProveedor({acredor:'1000004896',sociedad:'C031',no_cuenta:'208715062',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000004896</td>
										<td>C031</td>
										<td>208715062</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
									<tr @click="selectProveedor({acredor:'1000021670',sociedad:'C031',no_cuenta:'208715030',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000021670</td>
										<td>C031</td>
										<td>208715030</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
									<tr @click="selectProveedor({acredor:'1000022040',sociedad:'C031',no_cuenta:'208715069',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000022040</td>
										<td>C031</td>
										<td>208715069</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
									<tr @click="selectProveedor({acredor:'1000032516',sociedad:'C031',no_cuenta:'208715050',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000032516</td>
										<td>C031</td>
										<td>208715050</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
									<tr @click="selectProveedor({acredor:'1000035494',sociedad:'C031',no_cuenta:'208715064',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000035494</td>
										<td>C031</td>
										<td>208715064</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
									<tr @click="selectProveedor({acredor:'1000053800',sociedad:'C031',no_cuenta:'208715052',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000053800</td>
										<td>C031</td>
										<td>208715052</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
									<tr @click="selectProveedor({acredor:'1000134465',sociedad:'C031',no_cuenta:'208715056',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000134465</td>
										<td>C031</td>
										<td>208715056</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>

									<tr @click="selectProveedor({acredor:'1000134466',sociedad:'C031',no_cuenta:'208715066',razon_social:'CANON MEXICANA S DE RL DE CV'})">
										<td>&nbsp;</td>
										<td>1000134466</td>
										<td>C031</td>
										<td>208715066</td>
										<td>CANON MEXICANA S DE RL DE CV</td> 
									</tr>
								</table>

								<table v-if="ejercicioActivo == 'ejercicio-3'" class="table-proveedor table-format">
									<tr>
										<td><i class="far fa-clone"></i></td>
										<td data-v-step="43">Acreedor</td>
										<td>Sociedad</td>
										<td>Nº cta.anterior</td>
										<td>Razón Social</td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000456625',sociedad:'C031',no_cuenta:'757695',razon_social:'PROCTER AND GAMBLE MEXICO INC'})">
										<td>&nbsp;</td>
										<td>1000456625</td>
										<td>C031</td>
										<td>757695</td>
										<td>PROCTER AND GAMBLE MEXICO INC</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000456626',sociedad:'C031',no_cuenta:'757695640',razon_social:'PROCTER AND GAMBLE MEXICO INC'})">
										<td>&nbsp;</td>
										<td>1000456626</td>
										<td>C031</td>
										<td>757695640</td>
										<td>PROCTER AND GAMBLE MEXICO INC</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000456627',sociedad:'C031',no_cuenta:'757695630',razon_social:'PROCTER AND GAMBLE MEXICO INC'})">
										<td>&nbsp;</td>
										<td>1000456627</td>
										<td>C031</td>
										<td>757695630</td>
										<td>PROCTER AND GAMBLE MEXICO INC</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000466027',sociedad:'C031',no_cuenta:'757695643',razon_social:'PROCTER AND GAMBLE MEXICO INC'})">
										<td>&nbsp;</td>
										<td>1000466027</td>
										<td>C031</td>
										<td>757695643</td>
										<td>PROCTER AND GAMBLE MEXICO INC</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000466028',sociedad:'C031',no_cuenta:'757695642',razon_social:'PROCTER AND GAMBLE MEXICO INC'})">
										<td>&nbsp;</td>
										<td>1000466028</td>
										<td>C031</td>
										<td>757695642</td>
										<td>PROCTER AND GAMBLE MEXICO INC</td> 
									</tr> 
								</table>

								<table v-if="ejercicioActivo == 'ejercicio-4'" class="table-proveedor table-format">
									<tr>
										<td><i class="far fa-clone"></i></td>
										<td data-v-step="43">Acreedor</td>
										<td>Sociedad</td>
										<td>Nº cta.anterior</td>
										<td>Razón Social</td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000047614',sociedad:'C031',no_cuenta:'505800',razon_social:'ESTEVEZ SA CV'})">
										<td>&nbsp;</td>
										<td>1000047614</td>
										<td>C031</td>
										<td>505800</td>
										<td>ESTEVEZ SA CV</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000047615',sociedad:'C031',no_cuenta:'505800630',razon_social:'ESTEVEZ SA CV'})">
										<td>&nbsp;</td>
										<td>1000047615</td>
										<td>C031</td>
										<td>505800630</td>
										<td>ESTEVEZ SA CV</td> 
									</tr> 
								</table>

								<table v-if="ejercicioActivo == 'evaluacion-1'" class="table-proveedor table-format">
									<tr>
										<td><i class="far fa-clone"></i></td>
										<td data-v-step="43">Acreedor</td>
										<td>Sociedad</td>
										<td>Nº cta.anterior</td>
										<td>Razón Social</td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000022565',sociedad:'C031',no_cuenta:'301922',razon_social:'CREMERIA AMERICANA SA DE CV'})">
										<td>&nbsp;</td>
										<td>1000022565</td>
										<td>C031</td>
										<td>301922</td>
										<td>CREMERIA AMERICANA SA DE CV</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000046211',sociedad:'C031',no_cuenta:'301922900',razon_social:'CREMERIA AMERICANA SA DE CV'})">
										<td>&nbsp;</td>
										<td>1000046211</td>
										<td>C031</td>
										<td>301922900</td>
										<td>CREMERIA AMERICANA SA DE CV</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000037579',sociedad:'C031',no_cuenta:'301922902',razon_social:'CREMERIA AMERICANA SA DE CV'})">
										<td>&nbsp;</td>
										<td>1000037579</td>
										<td>C031</td>
										<td>301922902</td>
										<td>CREMERIA AMERICANA SA DE CV</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000022568',sociedad:'C031',no_cuenta:'301922904',razon_social:'CREMERIA AMERICANA SA DE CV'})">
										<td>&nbsp;</td>
										<td>1000022568</td>
										<td>C031</td>
										<td>301922904</td>
										<td>CREMERIA AMERICANA SA DE CV</td> 
									</tr> 
								</table>

								<table v-if="ejercicioActivo == 'evaluacion-2'" class="table-proveedor table-format">
									<tr>
										<td><i class="far fa-clone"></i></td>
										<td data-v-step="43">Acreedor</td>
										<td>Sociedad</td>
										<td>Nº cta.anterior</td>
										<td>Razón Social</td>
									</tr>
									<tr @click="selectProveedor({acredor:'1000047614',sociedad:'C031',no_cuenta:'505800',razon_social:'ESTEVEZ SA CV'})">
										<td>&nbsp;</td>
										<td>1000047614</td>
										<td>C031</td>
										<td>505800</td>
										<td>ESTEVEZ SA CV</td> 
									</tr> 
									<tr @click="selectProveedor({acredor:'1000045617',sociedad:'C031',no_cuenta:'50580268',razon_social:'ESTEVEZ SA'})">
										<td>&nbsp;</td>
										<td>1000045617</td>
										<td>C031</td>
										<td>50580268</td>
										<td>ESTEVEZ SA</td> 
									</tr> 
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>